module.exports = __webpack_public_path__ + "img/logo-pico.fa769e00.svg";